/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/launch" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdLaunchCacheKeys } from "./constants";
import type { PostEmailIpWarmingAppGroupIdLaunchProps, EmailIpWarmingLaunchResult } from "./types";

export const postEmailIpWarmingLaunch = reactQueryMutationAdapter(
  emailIpWarmingAppGroupIdLaunchCacheKeys,
  (props: PostEmailIpWarmingAppGroupIdLaunchProps): Promise<EmailIpWarmingLaunchResult> => {
    return fetch(
      `/email/ip_warming/${props.appGroupId}/launch${props.planId ? `/${props.planId}` : ""}`,
      "POST",
      props,
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
